module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA6ElEQVQ4T+3UO07DQBQF0Hvt0oQFUKR1a/stASqClI4VBOioYQVQ0yFYASW/CnYww6whDQuAuPVFE4mPUKTI1pS59ZtTzPsQicPomdlY0j3J0RBf0qekaQhhvgTrut7NsuwFwAeARU90C8B213V7IYTX/+C59/6yD2hmZwAuNuBPUzZ/uH6AVo5NVVX7eZ4/SbqT9Lie+a0geUDykOTEOff8vXo3AGZ9oBW1t977I5ZlOSqK4p1kXKHBkbRo23aHTdMck7weLP15KOmEZubiwUkEugg+AGhSgADeIjgBcJUIPF12OWWSg1/266okcS+tiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/five_active.png
// module id = hEMW
// module chunks = 1